import React, { Component } from 'react';
import { connect } from 'react-redux'
import {bindActionCreators} from 'redux';
import SeriesTimePicker from '../components/SeriesTimePicker';

import { setSelectedChildEvent, selectChildEventAndContinue, setChildEventAdditionalInfo, setSelectedDate } from '../actions/event-series';
import { getSeriesConfig } from 'checkout/selectors/ui';
import { setListingItem } from 'listing/helpers/storage';
import { getLowInventoryMessage, getSoldOutMessage, getEventTimeFormatted, hasActiveInventoryFilter } from '../selectors/eventSeries';
import { createLoadingSelector } from 'checkout/selectors/helpers';
import { clearSelectedPriceLevels } from '../../ticket-picker/actions/ticket-picker';
import { clearSelectedBundles } from '../../bundle-picker/actions/bundle-picker';
import { clearSelectedProducts } from '../../product-picker/actions/product-picker';

class SeriesTimePickerContainer extends Component<ContainerProps> {
    onEventTimeChange = (childEventId, childEventAdditionalInfo) => {
        this.props.setSelectedChildEvent(childEventId);
        this.props.setChildEventAdditionalInfo(childEventAdditionalInfo);
        this.props.selectChildEventAndContinue(childEventId, false);
        this.setState({selectedEventId: childEventId}, () => {setListingItem(this.props.listingSlug, 'selectedEventId', this.state.selectedEventId)});
        this.setState({seriesChildAdditionalInfo: childEventAdditionalInfo});
        this.props.clearSelectedPriceLevels();
        this.props.clearSelectedBundles();
        this.props.clearSelectedProducts();
        this.props.setIsDateChanging(false);
    };

    openTicketPicker = () => {
        this.props.selectChildEventAndContinue(this.state.selectedEventId);
    };

    render() {
        return (
            <SeriesTimePicker
                locale={this.props.locale}
                eventTimes={this.props.eventTimes}
                onEventTimeChange={this.onEventTimeChange}
                onContinueClick={this.openTicketPicker}
                selectedDay={this.props.selectedDay}
                selectedDayDate={this.props.selectedDateObject}
                calendarType={this.props.calendarType}
                showButtonTimeRanges={this.props.showButtonTimeRanges}
                showSoldOut={this.props.showSoldOut}
                selectedDate={this.props.selectedDate}
                selectedChildEvent={this.props.selectedChildEvent}
                loading={this.props.loading}
                getLowInventoryMessage={this.props.getLowInventoryMessage}
                getSoldOutMessage={this.props.getSoldOutMessage}
                getEventTimeFormatted={this.props.getEventTimeFormatted}
                hasActiveInventoryFilter={this.props.hasActiveInventoryFilter}
                inventoryFilterResults={this.props.inventoryFilterResults}
                autoFocus={this.props.autoFocus}
                selectedDateDescription={this.props.selectedDateDescription}
                networkError={this.props.networkError}
                setSelectedDate={this.props.setSelectedDate}
                setSelectedChildEvent={this.props.setSelectedChildEvent}
                setChildEventAdditionalInfo={this.props.setChildEventAdditionalInfo}
                isChangingDate={this.props.isChangingDate}
                setIsDateChanging={this.props.setIsDateChanging}
            />
        );
    }
}

const eventTimesLoading = createLoadingSelector("EVENT_TIMES");
const mapStateToProps = (state, props) => {
    let showSoldOut = getSeriesConfig(state).showSoldOut;
    let eventTimes = state.eventSeries.eventTimes;
    if(showSoldOut === false) {
        eventTimes = eventTimes.filter((event) => event.eventStatus !== "sold_out");
    }
    return {
        eventTimes,
        locale: state.intl.locale,
        calendarType: getSeriesConfig(state).calendarType,
        showButtonTimeRanges: getSeriesConfig(state).showButtonTimeRanges,
        selectedChildEvent: state.eventSeries.selectedChildEvent,
        showSoldOut,
        listingSlug: state.ui.listingSlug,
        selectedDateObject: state.eventSeries.selectedDateObject,
        loading: eventTimesLoading(state),
        getLowInventoryMessage: getLowInventoryMessage(state),
        getSoldOutMessage: getSoldOutMessage(state),
        getEventTimeFormatted: getEventTimeFormatted(state),
        hasActiveInventoryFilter: hasActiveInventoryFilter(state),
        inventoryFilterResults: state.inventoryFilter.filterResults,
        selectedDateDescription: state.eventSeries.selectedDateDescription,
        networkError: state?.eventSeries?.networkError
    }
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        setSelectedChildEvent,
        selectChildEventAndContinue,
        setChildEventAdditionalInfo,
        clearSelectedPriceLevels,
        clearSelectedProducts,
        clearSelectedBundles,
    }, dispatch);
};

SeriesTimePickerContainer.propTypes = {
};

export default connect(mapStateToProps, mapDispatchToProps)(SeriesTimePickerContainer)
